export default "__VITE_ASSET__DCznAxFY__"